import axiosInstance from './axios';

export const gamesService = {
  getCollections: async (): Promise<any> => {
    const siteId = process.env.REACT_APP_TENANT_ID || '1';
    const response = await axiosInstance.get(`/client/games/collections?siteId=${siteId}`);
    return response.data;
  },

  launchGame: async (gameId: number | string, clientType: 'desktop' | 'mobile'): Promise<any> => {
    const response = await axiosInstance.post(`/client/games/${gameId}/launch`, {
      clientType,
      currency: 'USD',
    });
    return response.data;
  },

  launchDemoGame: async (
    gameId: number | string,
    clientType: 'desktop' | 'mobile',
  ): Promise<any> => {
    const siteId = process.env.REACT_APP_TENANT_ID || '1';
    const response = await axiosInstance.post(`/client/games/${gameId}/demo?siteId=${siteId}`, {
      clientType,
      currency: 'USD',
    });
    return response.data;
  },

  getRoomStats: async (gameId: number | string): Promise<any> => {
    const siteId = process.env.REACT_APP_TENANT_ID || '1';
    const response = await axiosInstance.get(`/client/games/${gameId}/room?siteId=${siteId}`);
    return response.data;
  },

  resetRoomStats: async (gameId: number | string): Promise<any> => {
    const siteId = process.env.REACT_APP_TENANT_ID || '1';
    const response = await axiosInstance.post(
      `/client/games/${gameId}/room/reset?siteId=${siteId}`,
    );
    return response.data;
  },

  getCategoryGames: async (
    slug: string,
    page = 1,
    pageSize = 16,
    search?: string,
    sortBy?: string,
    providerIds?: number[],
    gameType?: string,
  ): Promise<any> => {
    const siteId = process.env.REACT_APP_TENANT_ID || '1';
    let url = `/client/games/categories/${slug}/games?page=${page}&pageSize=${pageSize}&siteId=${siteId}`;
    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }
    if (sortBy) {
      url += `&sortBy=${encodeURIComponent(sortBy)}`;
    }
    if (providerIds && providerIds.length > 0) {
      providerIds.forEach((id) => {
        url += `&providers=${id}`;
      });
    }
    if (gameType) {
      url += `&gameType=${encodeURIComponent(gameType)}`;
    }
    const response = await axiosInstance.get(url);
    return response.data;
  },

  getCategoryProviders: async (slug: string, gameType?: string): Promise<any> => {
    const siteId = process.env.REACT_APP_TENANT_ID || '1';
    let url = `/client/games/categories/${slug}/providers?siteId=${siteId}`;
    if (gameType) {
      url += `&gameType=${encodeURIComponent(gameType)}`;
    }
    const response = await axiosInstance.get(url);
    return response.data;
  },

  searchGames: async (query: string, page = 1, pageSize = 16): Promise<any> => {
    const siteId = process.env.REACT_APP_TENANT_ID || '1';
    const response = await axiosInstance.get(
      `/client/games/search?search=${encodeURIComponent(query)}&page=${page}&pageSize=${pageSize}&siteId=${siteId}`,
    );
    return response.data;
  },

  closeGame: async (gameId: number | string): Promise<any> => {
    const response = await axiosInstance.post(`/client/games/${gameId}/session/close`);
    return response.data;
  },

  getGameStatistics: async (gameId: number | string): Promise<any> => {
    const siteId = process.env.REACT_APP_TENANT_ID || '1';
    const response = await axiosInstance.get(
      `/client/games/wins?siteId=${siteId}&gameId=${gameId}`,
    );
    return response.data;
  },

  getBetRound: async (roundIdCasino: string | number): Promise<any> => {
    const response = await axiosInstance.get(`/client/games/round/${roundIdCasino}`);
    return response.data;
  },
};
